import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { SUB_SIDEBAR_KEYS } from 'consts/sidebar'
import { IEditorState } from 'store/types/editor'
import { getDeviceVersion } from 'utils'

export const getInitialState = (): IEditorState => ({
  activeTimelineItems: [],
  activeSidebarTab: getDeviceVersion(SMALL_DESKTOP_SIZE_BREAKPOINT)
    ? null
    : SUB_SIDEBAR_KEYS.AI_VIDEO,
  timelineRulerSliceDuration: 5,
  isMobileSubSidebarOpen: false,
  isMobileInnerSliderOpen: false,
  activeAsideOverlayKey: null,
  isTimelineItemDragging: false,
  isTimelineItemResizing: false,
  isBuffering: false,
  apiErrorPopupData: {
    type: '',
    message: ''
  },
  isWelcomePopupOpen: false,
  clipboard: null,
  libraryFonts: [],
  selectedAspectRatioKey: null,
  // TODO: remove when canvas text editing is enabled
  textSidebarPulseToken: 0
})
